/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { closeDialog, openDialog } from '../../../../../app/dialog/dialog.actions';
import { useSelect } from '../../../../../utils/selector.utils';
import { annualsSelectors } from '../../../../../app/resource/annuals/annuals.selectors';
import { IAnnual } from '../../../../../app/resource/annuals/annuals.types';
import { HiPencil } from 'react-icons/hi2';
import { FaTrash } from 'react-icons/fa6';
import { deleteAnnual } from '../../../../../app/page/annuals/annuals.actions';
import { reverse, sortBy } from 'lodash';

export const AnnualAndPeriods = () => {
  const dispatch = useDispatch();

  const now = new Date();
  const currentYear = new Date().getFullYear();
  const yearsOptions = [currentYear, currentYear + 1, currentYear + 2];
  let annuals = useSelect(annualsSelectors.selectResourceList) as IAnnual[];
  annuals = reverse(sortBy(annuals, 'year'));

  const showAddButton = yearsOptions.find((year) => !annuals.find((a) => a.year == year));

  const resolveQuarterColor = useCallback((startDateString: Date, endDateString: Date) => {
    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);

    if (startDate > now) {
      return 'red-bg';
    } else if (startDate <= now && endDate > now) {
      return 'yellow-bg';
    } else {
      return 'lightDarkGray-bg';
    }
  }, []);

  return (
    <div className="col px-0">
      <div className="field-container px-2 mb-5">
        <div className="panel theme-gradient-2 py-1 px-2 flex aic mb-3">
          <h2 className="f-14 white bold">ANNUALS</h2>
        </div>
        <div className="row email-template">
          <div className="col-12">
            {showAddButton && (
              <div className="row">
                <div className="col-12 flex justify-end">
                  <button
                    className="btn btn-lg f-14 white-bg p-1 my-2 popup_button"
                    title="Create new board"
                    style={{ border: '2px solid #edf2f5', boxShadow: 'none' }}
                    onClick={() => {
                      dispatch(openDialog('annualAndPeriodsFormDialog'));
                    }}
                  >
                    <i className="icon icon-plus" /> Add annual
                  </button>
                </div>
              </div>
            )}
            <div className="border-radius-1">
              {annuals.map((annual) => (
                <React.Fragment key={annual.id}>
                  <div className="p-2">
                    <div style={{ width: '49rem' }} className="flex justify-between">
                      <div>
                        <div className="f-2 mb-2">Year: {annual.year}</div>
                        <div className="mb-2 ">
                          {annual.year < now.getFullYear() ? (
                            <>Past active periods in your company in {annual.year}</>
                          ) : (
                            <>You can edit dates for each of active periods in this Year</>
                          )}
                        </div>
                        <div className="flex white mb-2">
                          {annual.quarters.map((quarter) => (
                            <span
                              key={quarter.id}
                              className={`border-radius-1 mr-1 p-1 ${resolveQuarterColor(
                                quarter.startDate,
                                quarter.endDate,
                              )}`}
                            >
                              P{quarter.number}:{' '}
                              {new Intl.DateTimeFormat('en-US', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                              }).format(new Date(quarter.startDate))}
                            </span>
                          ))}
                        </div>
                      </div>
                      <div className="align-center flex" style={{ fontSize: 13 }}>
                        <div
                          className="mr-2 p-1 border-radius-100 dark-gray-border pointer"
                          style={{ height: 35, width: 35 }}
                          onClick={() => {
                            dispatch(openDialog('annualAndPeriodsFormDialog', { annual }));
                          }}
                        >
                          <HiPencil />
                        </div>
                        <div
                          className="p-1 border-radius-100 dark-gray-border pointer"
                          style={{ height: 35, width: 35 }}
                          onClick={() => {
                            dispatch(
                              openDialog('confirmation', {
                                title: 'Delete annual',
                                message: 'Are you sure you want to delete this annual?',
                                onConfirm: () => {
                                  dispatch(deleteAnnual(annual.id));
                                },
                                onDeny: () => dispatch(closeDialog('confirmation')),
                                styles: { zIndex: '999999999', position: 'fixed' },
                              }),
                            );
                          }}
                        >
                          <FaTrash />
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
};
